angular.module('labApp').service('SampleLocationIds', function($resource) {
   var self=this;
   var assocSampleLocIdsResource = $resource('/api/v1.0/lab/associated_sample_location_ids/:slug/');

   self.getAssociatedSampleLocationIds = function(fpc_slug) {
       return assocSampleLocIdsResource.query({slug: fpc_slug}).$promise;
   }
});